'use client';

import { Suspense, useState } from 'react';

import { useRouter } from 'next/navigation';

import { useQueryParams } from '@/modules/common/hooks/useQueryParams';
import { useSession } from '@/modules/common/hooks/useSession';
import { BASE_SITEMAP_URL } from '@/modules/common/services/constants';
import RegisterModal from '@/modules/register/components/modal/GenericRegisterModal';
import StartSignin from '@/modules/register/components/modal/email/StartSignin';

export default function SignPage() {
  return (
    <Suspense>
      <SignPageContent />
    </Suspense>
  );
}

function SignPageContent() {
  const router = useRouter();
  const [callback] = useQueryParams<string>('callback', '');
  const { isAuthenticated } = useSession();
  const [authInProgress, setAuthInProgress] = useState(false);

  const referrerPageIsDS = document?.referrer?.includes(BASE_SITEMAP_URL);

  const redirect = (isAuthSuccess = isAuthenticated) => {
    if (callback && isAuthSuccess) {
      router.push(callback);
    } else if (!callback && referrerPageIsDS) {
      router.back();
    } else {
      router.push('/');
    }
  };

  const handleToggleModal = (isAuthModalOpen: boolean) => {
    if (!isAuthModalOpen) {
      redirect();
    }
  };

  if (!isAuthenticated || authInProgress) {
    return (
      <div className="h-[48vh]">
        <RegisterModal
          open={true}
          setOpen={(isOpen) => {
            handleToggleModal(isOpen);
          }}
          componentModal={
            <StartSignin
              onSignIn={() => {
                setAuthInProgress(true);
                redirect(true);
              }}
            />
          }
        />
      </div>
    );
  }

  redirect();

  return null;
}
